import { gql } from '@grandvisionhq/graphql';
import { shoppinglistVariantFragment } from '../fragments/variant.js';

const removeFromShoppinglistFragment = gql`
  fragment RemoveFromShoppinglistFragment on RemoveFromShoppinglistSuccessResponse {
    result {
      id
      items {
        name
        quantity
        sku
        variant {
          ...ShoppinglistVariantFragment
        }
      }
    }
  }
  ${shoppinglistVariantFragment}
`;
const failuresFragment = gql`
  fragment RemoveFromShoppinglistFailureFragment on RemoveFromShoppinglistFailureResponse {
    failures {
      ... on ShoppinglistNotFoundFailure {
        message
      }
      ... on ShoppinglistAuthorizationFailure {
        message
      }
      ... on ShoppinglistValidationFailure {
        message
      }
      ... on ShoppinglistFailure {
        message
      }
    }
  }
`;
var REMOVE_FROM_SHOPPING_LIST = gql`
  mutation RemoveFromShoppinglist($input: RemoveFromShoppinglistInput!) {
    removeFromShoppinglist(input: $input) {
      ...RemoveFromShoppinglistFragment
      ...RemoveFromShoppinglistFailureFragment
    }
  }
  ${removeFromShoppinglistFragment}
  ${failuresFragment}
`;

export { REMOVE_FROM_SHOPPING_LIST as default, failuresFragment, removeFromShoppinglistFragment };
//# sourceMappingURL=remove-from-shopping-list.js.map
